import React from "react";
import Layout from "./Shared/Layout";
import { useNavigate } from "react-router-dom";
import { useWishlist } from "../context/wishlistContext";
import Breadcrumb from "./Breadcrumb";
import { formatCurrencyAmount } from "../utils/currency";

const Wishlist = () => {
    const navigate = useNavigate();

    const { wishlist, loading, removeFromWishlist } = useWishlist();

    const wishListData = Array.isArray(wishlist) ? wishlist : [];

    const getProductInfo = (item) => {
        return item?.productFullInfo || item?.product_full_info || null;
    };

    const getProductImage = (item) => {
        const productInfo = getProductInfo(item);

        if (productInfo?.thumbnail_full_url) {
            return productInfo.thumbnail_full_url;
        }

        if (
            Array.isArray(productInfo?.images_full_url) &&
            productInfo.images_full_url.length > 0
        ) {
            return productInfo.images_full_url[0]?.path;
        }

        if (
            Array.isArray(productInfo?.images) &&
            productInfo.images.length > 0
        ) {
            return productInfo.images[0];
        }

        return "./images/defaultImage.png";
    };

    const getProductName = (item) => {
        const productInfo = getProductInfo(item);
        return productInfo?.name || "Product";
    };

    const getProductPrice = (item) => {
        const productInfo = getProductInfo(item);
        return productInfo?.unit_price ?? 0;
    };

    const onProductDetail = (item) => {
        const productInfo = getProductInfo(item);

        if (!productInfo?.slug) {
            return;
        }

        localStorage.setItem("productId", productInfo?.id || "");
        const url = `/product/${productInfo.slug}`;
        navigate(url);
        localStorage.setItem("priviousUrl", url);
    };

    const removewishProductByLoginProductId = async (item) => {
        const isConfirmed = window.confirm("Are you sure you want to delete this item?");
        if (!isConfirmed) return;

        const productId = item?.product_id || getProductInfo(item)?.id;

        if (!productId) return;

        await removeFromWishlist(productId);
    };

    const onBuyNow = (item) => {
        const productInfo = getProductInfo(item);

        if (!productInfo) return;

        navigate("/cart", {
            state: {
                product: productInfo,   // 👈 yaha full data bhej rahe ho
            },
        });
    };

    return (
        <Layout showBreadcrumb={false}>
            <section className="d-flex justify-content-center">
                <div className="container pt-sm-4 pt-2 pb-sm-5 pb-2 ">
                    <section className="contact-banner-sec">
                        <div className="container-fluid">
                            <div className="page-header">
                                <h1>Wishlist</h1>
                            </div>
                            <Breadcrumb />
                        </div>
                    </section>

                    <div className="row justify-content-center product_order_data_wrapper_main">
                        <div className="col-xl-8 col-lg-9 col-md-10 col-12">
                            <div className="all_page_heading">
                                {loading ? (
                                    <div className="mt-4">
                                        <p className="text-white">Loading...</p>
                                    </div>
                                ) : wishListData.length > 0 ? (
                                    <div className="product_order_data_wrapper d-flex my-lg-5 my-4 wishlist_content p-2">
                                        <div className="">
                                            {wishListData.map((item, j) => {
                                                const imagePath = getProductImage(item);
                                                const productName = getProductName(item);
                                                const productPrice = getProductPrice(item);

                                                return (
                                                    <React.Fragment key={item?.id || j}>
                                                        <div className="product_order_content row p-lg-3">
                                                            <div className="product_order__image col-sm-2 col-12">
                                                                <img
                                                                    className="w-100"
                                                                    onClick={() => onProductDetail(item)}
                                                                    style={{ cursor: "pointer" }}
                                                                    src={imagePath}
                                                                    alt={productName}
                                                                    onError={(e) => {
                                                                        e.target.onerror = null;
                                                                        e.target.src = "./images/defaultImage.png";
                                                                    }}
                                                                />
                                                            </div>

                                                            <div className="product_order_name col-sm-7 col-12">
                                                                <h5
                                                                    className="product_name"
                                                                    onClick={() => onProductDetail(item)}
                                                                    style={{ cursor: "pointer" }}
                                                                >
                                                                    {productName}
                                                                </h5>
                                                                <div>
                                                                    <p style={{ color: "#fffffff0", fontWeight: "500" }}>
                                                                        {formatCurrencyAmount(productPrice, getProductInfo(item))}
                                                                    </p>
                                                                </div>
                                                            </div>

                                                            <div className="col-sm-3">
                                                                <div className="wishlist_buttons p-0 d-flex justify-content-sm-end align-items-end">
                                                                    {/* <button
                                                                        className="buy_now_icon web_buttons"
                                                                        onClick={() => onBuyNow(item)}
                                                                    >
                                                                        <svg
                                                                            id="Layer_1"
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                                                            xmlnssvgjs="http://svgjs.dev/svgjs"
                                                                            viewBox="0 0 24 24"
                                                                            width="25"
                                                                            height="25"
                                                                        >
                                                                            <g transform="matrix(1,0,0,1,0,0)" width="100%" height="100%">
                                                                                <path
                                                                                    d="m20 24h-16c-2.2 0-4-1.8-4-4v-16c0-2.2 1.8-4 4-4h16c2.2 0 4 1.8 4 4v16c0 2.2-1.8 4-4 4z"
                                                                                    fill="#fa486f"
                                                                                    fillOpacity="0"
                                                                                    stroke="none"
                                                                                />
                                                                                <path
                                                                                    d="m21 16h-16c-.6 0-1-.4-1-1s.4-1 1-1h13c.4 0 .8-.2.9-.6l3-7c.1-.3.1-.7-.1-.9-.2-.3-.5-.5-.8-.5h-14.6l-.4-2.2c-.1-.5-.5-.8-1-.8h-2c-.6 0-1 .4-1 1s.4 1 1 1h1.2l1.6 8h-.8c-1.7 0-3 1.3-3 3 0 1.4.9 2.5 2.2 2.9-.1.3-.2.7-.2 1.1 0 1.7 1.3 3 3 3s3-1.3 3-3c0-.4-.1-.7-.2-1h4.4c-.1.3-.2.6-.2 1 0 1.7 1.3 3 3 3s3-1.3 3-3c0-.4-.1-.7-.2-1h1.2c.6 0 1-.4 1-1s-.4-1-1-1zm-14.2-9h12.7l-2.1 5h-9.6zm1.2 12c0 .6-.4 1-1 1s-1-.4-1-1 .4-1 1-1 1 .4 1 1zm10 0c0 .6-.4 1-1 1s-1-.4-1-1 .4-1 1-1 1 .4 1 1z"
                                                                                    fill="#000000"
                                                                                    stroke="none"
                                                                                />
                                                                            </g>
                                                                        </svg>
                                                                    </button> */}

                                                                    <button
                                                                        className="delete_wishlist_btn web_buttons"
                                                                        onClick={() => removewishProductByLoginProductId(item)}
                                                                    >
                                                                        <svg
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            x="0px"
                                                                            y="0px"
                                                                            width="20"
                                                                            height="20"
                                                                            viewBox="0 0 24 24"
                                                                        >
                                                                            <path
                                                                                d="M 10 2 L 9 3 L 4 3 L 4 5 L 5 5 L 5 20 C 5 20.522222 5.1913289 21.05461 5.5683594 21.431641 C 5.9453899 21.808671 6.4777778 22 7 22 L 17 22 C 17.522222 22 18.05461 21.808671 18.431641 21.431641 C 18.808671 21.05461 19 20.522222 19 20 L 19 5 L 20 5 L 20 3 L 15 3 L 14 2 L 10 2 z M 7 5 L 17 5 L 17 20 L 7 20 L 7 5 z M 9 7 L 9 18 L 11 18 L 11 7 L 9 7 z M 13 7 L 13 18 L 15 18 L 15 7 L 13 7 z"
                                                                                fill="#000000"
                                                                            />
                                                                        </svg>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="horizantal_line"></div>
                                                    </React.Fragment>
                                                );
                                            })}
                                        </div>
                                    </div>
                                ) : (
                                    <div className="mt-4">
                                        <p className="text-white">
                                            Your wishlist is empty! Start exploring and add your favorite products here.
                                        </p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </Layout>
    );
};

export default Wishlist;
